import {css} from "@emotion/react";

export const grid = css`
    display: grid;
    grid-column-gap: 24px;
    grid-row-gap: 24px;
`;
